import { toast } from '@hivebrite/design-system/Toast';

import copyToClipboard from 'hb-react/shared/utils/copyToClipboard';

export const getActionItems = (folderUrl, icons) => [
  {
    label: s__('MediaCenter|Copy link'),
    icon: icons.copyLink,
    onClick: () =>
      copyToClipboard(folderUrl, () =>
        toast.success(__('Link copied to clipboard')),
      ),
  },
];
